export default __webpack_public_path__ + "static/media/cyl3dstair.67c39f3f.jpg";